import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.533 5.472l.834-.834a2.16 2.16 0 0 0 0-3.054l-.952-.952a2.16 2.16 0 0 0-3.054 0l-.835.834 4.007 4.006zM11.467 2.527l-8.513 8.514L0 18l6.959-2.954 8.514-8.513z" />
  </svg>
);

export default SvgComponent;
